import Template from '../../component/Template.js';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { useParams } from "react-router-dom";

const STUDY_MODES = [
    { value: 'online', label: 'Online' },
    { value: 'offline', label: 'Offline' },
    { value: 'hybrid', label: 'Hybrid' }
];

export default function InternshipTopicCreate({ onClose }) {

    const [providers, setProviders] = useState([]);
    const [DISCIPLINE_OPTIONS, setDISCIPLINE_OPTIONS] = useState([]);

    const [formData, setFormData] = useState({
        offeredByType: 'vendor',
        providerid: '',
        topicName: '',
        eligibleDisciplines: [],
        totalSeats: 0, // Initialize as number for math
        internalSeats: '',
        externalSeats: '',
        studyMode: ''
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { http } = Api();
    const navigate = useNavigate();

    const handleClose = () => {
        if (onClose) {
            onClose();
        } else {
            navigate('/ino/internshiptopic');
        }
    };

    const { id } = useParams();
    const isEdit = Boolean(id);

    // --- 1. Logic Change: Fetch Providers & Reset Selection ---
    useEffect(() => {


        http.post(`College/getVendorsByUserType`, {
        }).then(response => {
            setProviders(response.data.data);
        }).catch(error => {
            console.error("Error in getVendorsByUserType:", error);
        });

    }, [formData.offeredByType]); // Dependency ensures this runs when toggle changes

    useEffect(() => {
        http.get(`College/collegeDisciplines`).then(response => {
            setDISCIPLINE_OPTIONS(response.data.data);
        }).catch(error => {
            console.error("Error in collegeDisciplines:", error);
        });
    }, []);

    useEffect(() => {

        if (isEdit) {
            loadTopicDetails();
        }

    }, [id]);

    const loadTopicDetails = async () => {

        try {
            const res = await http.get(`College/internship_topic_details`,{
                 params: { id }
            });
            const data = res.data.data;

            setFormData({
                offeredByType: data.offered_by_type,
                providerid: data.provider_id,
                topicName: data.internship_topic,
                eligibleDisciplines: data.disciplines.map(d => ({
                    value: d.id,
                    label: d.name
                })),
                totalSeats: data.total_seats,
                internalSeats: data.internal_seats,
                externalSeats: data.external_seats,
                studyMode: data.mode_of_study
            });

        } catch (err) {
            toast.error("Failed to load topic details");
        }
    };

    // --- Validation Logic ---
    const validateForm = () => {
        const newErrors = {};

        if (!formData.providerid) {
            newErrors.providerid = 'Provider name is required';
        }

        if (!formData.topicName.trim()) {
            newErrors.topicName = 'Internship Topic Name is required';
        } else if (formData.topicName.length < 3) {
            newErrors.topicName = 'Topic name must be at least 3 characters';
        }

        if (!formData.eligibleDisciplines || formData.eligibleDisciplines.length === 0) {
            newErrors.eligibleDisciplines = 'Please select at least one discipline';
        }

        // Seat Validation
        // if (formData.internalSeats === '' || parseInt(formData.internalSeats) < 0) {
        //     newErrors.internalSeats = 'Required';
        // }
        // if (formData.externalSeats === '' || parseInt(formData.externalSeats) < 0) {
        //     newErrors.externalSeats = 'Required';
        // }

        // Note: We removed the "Total != Internal + External" check 
        // because Total is now calculated automatically.

        if (!formData.studyMode) {
            newErrors.studyMode = 'Please select a mode of study';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // --- Handlers ---

    // --- 2. Logic Change: Automatic Total Calculation ---
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => {
            const newData = { ...prev, [name]: value };

            // // Check if we are typing in Internal or External seats
            // if (name === 'internalSeats' || name === 'externalSeats') {
            //     const internal = parseInt(name === 'internalSeats' ? value : prev.internalSeats) || 0;
            //     const external = parseInt(name === 'externalSeats' ? value : prev.externalSeats) || 0;

            //     // Automatically set Total Seats
            //     newData.totalSeats = internal + external;
            // }

            return newData;
        });

        // Clear specific field error
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handleDisciplineChange = (selectedOptions) => {
        setFormData(prev => ({
            ...prev,
            eligibleDisciplines: selectedOptions || []
        }));
        if (errors.eligibleDisciplines) {
            setErrors(prev => ({ ...prev, eligibleDisciplines: '' }));
        }
    };

    const handleModeChange = (e) => {
        setFormData(prev => ({ ...prev, studyMode: e.target.value }));
        if (errors.studyMode) setErrors(prev => ({ ...prev, studyMode: '' }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error('Please fix the errors before submitting');
            return;
        }

        setIsSubmitting(true);

        try {
            const payload = {
                offered_by_type: formData.offeredByType,
                provider_id: formData.providerid,
                topic_name: formData.topicName,
                disciplines: formData.eligibleDisciplines.map(d => d.value),
                total_seats: formData.totalSeats,
                internal_seats: formData.internalSeats,
                external_seats: formData.externalSeats,
                study_mode: formData.studyMode
            };

            const apiUrl = isEdit
                ? `College/updateTopic/${id}`
                : `College/addTopic`;

            const response = await http.post(apiUrl, payload);
            // const response = await http.post('College/addTopic', payload);
            toast.success(response.data.message || 'Internship Topic created successfully');

            // Close form after successful creation if onClose exists
           
             handleClose();
           
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || 'Failed to create topic');
        } finally {
            setIsSubmitting(false);
        }
    };

   

    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} theme="light" />
            <Template>
                <div className="container mb-5">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-12 col-lg-8 col-xl-7">
                            <div className="card shadow-lg border-0 rounded-4">
                                <div className="card-body p-4 p-md-5">

                                    {/* Header Section */}
                                    <div className="text-center mb-4">
                                        <div className="d-inline-flex align-items-center justify-content-center bg-success rounded-circle mb-3" style={{ width: '64px', height: '64px' }}>
                                            <i className="bi bi-briefcase-fill fs-2 text-white"></i>
                                        </div>
                                        <h2 className="fw-bold mb-2">

                                             {isEdit ? "Edit Internship Topic" : "Add Internship Topic"}
                                        </h2>
                                    </div>

                                    {/* Form */}
                                    <form onSubmit={handleSubmit}>

                                        {/* 1. Offered By Selection */}
                                        <div className="mb-4">
                                            <label className="form-label fw-semibold">
                                                Offered By <span className="text-danger">*</span>
                                            </label>

                                            <div className="card border-0 shadow-sm p-3 bg-light">

                                                <div className="input-group">
                                                    <span className="input-group-text bg-white border-end-0 text-muted ps-3">
                                                        <i className={`bi ${formData.offeredByType === 'vendor' ? 'bi-building' : 'bi-person'}`}></i>
                                                    </span>
                                                    <select
                                                        className={`form-select form-select-sml border-start-0 ps-2 ${errors.providerid ? 'is-invalid' : ''}`}
                                                        name="providerid"
                                                        value={formData.providerid}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Select {formData.offeredByType === 'vendor' ? 'IPO' : 'IPO'}</option>
                                                        {providers.map((provider) => (
                                                            <option key={provider.id} value={provider.id}>
                                                                {/* Assuming the API returns 'vendor_name' for both, or you might need {provider.vendor_name || provider.name} */}
                                                                {provider.vendor_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.providerid && <div className="invalid-feedback">{errors.providerid}</div>}
                                                </div>
                                            </div>
                                        </div>

                                        {/* 2. Internship Topic Name */}
                                        <div className="mb-4">
                                            <label htmlFor="topicName" className="form-label fw-semibold">
                                                Internship Topic Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control form-control-lg ${errors.topicName ? 'is-invalid' : ''}`}
                                                id="topicName"
                                                name="topicName"
                                                value={formData.topicName}
                                                onChange={handleInputChange}
                                                placeholder="e.g. AI in Healthcare"
                                                disabled={isSubmitting}
                                            />
                                            {errors.topicName && <div className="invalid-feedback">{errors.topicName}</div>}
                                        </div>

                                        {/* 3. Eligible Disciplines */}
                                        <div className="mb-4">
                                            <label className="form-label fw-semibold">
                                                Eligible Disciplines <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                isMulti
                                                name="eligibleDisciplines"
                                                options={DISCIPLINE_OPTIONS.map(d => ({ value: d.id, label: d.discipline_name }))}
                                                value={formData.eligibleDisciplines}
                                                onChange={handleDisciplineChange}
                                                className={`basic-multi-select ${errors.eligibleDisciplines ? 'is-invalid border border-danger rounded' : ''}`}
                                                classNamePrefix="select"
                                                placeholder="Select disciplines..."
                                            />
                                            {errors.eligibleDisciplines && <div className="text-danger small mt-1">{errors.eligibleDisciplines}</div>}
                                        </div>

                                        {/* 4. Seats Configuration (Updated Logic) */}
                                        {/* <div className="mb-4">
                                            <label className="form-label fw-semibold">Seat Distribution <span className="text-danger">*</span></label>
                                            <div className="row g-3">

                                                
                                                <div className="col-md-4">
                                                    <label className="small text-muted mb-1">Internal</label>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        className={`form-control ${errors.internalSeats ? 'is-invalid' : ''}`}
                                                        name="internalSeats"
                                                        value={formData.internalSeats}
                                                        onChange={handleInputChange}
                                                        placeholder="Qty"
                                                    />
                                                    {errors.internalSeats && <div className="invalid-feedback">{errors.internalSeats}</div>}
                                                </div>

                                              
                                                <div className="col-md-4">
                                                    <label className="small text-muted mb-1">External</label>
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        className={`form-control ${errors.externalSeats ? 'is-invalid' : ''}`}
                                                        name="externalSeats"
                                                        value={formData.externalSeats}
                                                        onChange={handleInputChange}
                                                        placeholder="Qty"
                                                    />
                                                    {errors.externalSeats && <div className="invalid-feedback">{errors.externalSeats}</div>}
                                                </div>

                                               
                                                <div className="col-md-4">
                                                    <label className="small text-muted mb-1">Total Seats (Auto)</label>
                                                    <input
                                                        type="number"
                                                        readOnly
                                                        className="form-control "
                                                        name="totalSeats"
                                                        value={formData.totalSeats}
                                                    // onChange removed because it's calculated
                                                    />
                                                </div>
                                            </div>
                                        </div> */}

                                        {/* 5. Mode of Study */}
                                        <div className="mb-4">
                                            <label className="form-label fw-semibold">
                                                Mode of Study <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                className={`form-select form-select-sml ${errors.studyMode ? 'is-invalid' : ''}`}
                                                name="studyMode"
                                                value={formData.studyMode}
                                                onChange={handleModeChange}
                                            >
                                                <option value="">Select Mode</option>
                                                {STUDY_MODES.map(mode => (
                                                    <option key={mode.value} value={mode.value}>{mode.label}</option>
                                                ))}
                                            </select>
                                            {errors.studyMode && <div className="invalid-feedback">{errors.studyMode}</div>}
                                        </div>

                                        {/* Action Buttons */}
                                        <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-4 pt-3">
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary px-4"
                                                onClick={handleClose}
                                                disabled={isSubmitting}
                                            >
                                                Close
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-primary px-4"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Saving...
                                                    </>
                                                ) : isEdit ?(
                                                    <>
                                                        <i className="bi bi-check-circle me-2"></i>
                                                        Update Topic
                                                    </>
                                                ):(
                                                    <>
                                                        <i className="bi bi-check-circle me-2"></i>
                                                        Create Topic
                                                    </>

                                                )}
                                            
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Template>
        </>
    );
}